import React from 'react'
import { Modal } from 'react-bootstrap';

const DisplayUser = ({ show, hide, singleUser }) => {
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
        onHide={hide}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>User Details</h5>
        </Modal.Header>
        <Modal.Body>
          <div className='ml-3'>
            <h6>First Name</h6>
            <p className='ml-2'>{singleUser?.firstName}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Last Name</h6>
            <p className='ml-2'>{singleUser?.lastName}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Phone Number</h6>
            <p className='ml-2'>{singleUser?.phoneNumber}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Email Address</h6>
            <p className='ml-2'>{singleUser?.emailAddress}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />

            <h6>Username</h6>
            <p className='ml-2'>{singleUser?.username}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Status</h6>
            <p className='ml-2'>{singleUser?.status?.name}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Groups</h6>
            {singleUser?.groups?.length ? (
              <div className='d-flex' style={{ gap: 10 }}>
                {singleUser?.groups?.map((group) => (
                  <div
                    className='d-flex mt-2 pl-1 pb-1 pr-1'
                    key={group.id}
                    style={{
                      border: "1px #eee solid",
                      backgroundColor: "#e9ecef",
                      maxWidth: 100,
                      borderRadius: 5,
                    }}
                  >
                    {group.name}
                  </div>
                ))}
              </div>
            ) : (
              <p>No Group(s) found for selected user</p>
            )}
            <div
              className='mt-3 mb-3'
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Locations</h6>
            <div
              className='d-flex flex-wr
      ap mt-3'
            >
              {singleUser?.locations &&
                singleUser?.locations[0]?.map((location, index) => (
                  <p
                    style={{
                      cursor: "pointer",
                      marginLeft: index === 0 ? 20 : "",
                    }}
                  >
                    {location.name}
                    {location.name !== undefined && (
                      <i
                        className='fa fa-chevron-right ml-1 mr-1 mb-3'
                        style={{
                          fontSize: 13,
                          display: index == singleUser?.locations[0]?.length -1 ? "none" : "",
                          color: "#0000ff",
                        }}
                      />
                    )}
                  </p>
                ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DisplayUser